<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="类别">
              <j-dict-select-tag dictCode="bus_info_shop_type" v-model="queryParam.type"></j-dict-select-tag>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="等级">
              <j-dict-select-tag dictCode="bus_info_shop_grade" v-model="queryParam.grade"></j-dict-select-tag>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="名称">
              <j-input v-model="queryParam.name"> </j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-space>
                <a-button class="query-banner-btn" type="primary" @click="searchQuery">查询</a-button>
                <a-button class="query-banner-btn" type="primary" @click="searchReset">重置</a-button>
              </a-space>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('信息馆全球数据记录表')">导出</a-button>
      <a-upload
        name="file"
        :showUploadList="false"
        :multiple="false"
        :headers="tokenHeader"
        :action="importExcelUrl"
        @change="handleImportExcel"
      >
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ fixed: true, selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无此图片</span>
          <img
            v-else
            :src="getImgView(text)"
            height="25px"
            alt="图片不存在"
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无此文件</span>
          <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="uploadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <!-- <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </span>
      </a-table>
    </div>

    <busInfoShopDataRecords-modal ref="modalForm" @ok="modalFormOk"></busInfoShopDataRecords-modal>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import BusInfoShopDataRecordsModal from './modules/BusInfoShopDataRecordsModal'
import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
import JInput from '@/components/jeecg/JInput.vue'
export default {
  name: 'BusInfoShopDataRecordsList',
  mixins: [JeecgListMixin],
  components: {
    BusInfoShopDataRecordsModal,
    JInput,
  },
  data() {
    return {
      description: '信息馆全球数据记录表管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '地区',
          align: 'center',
          dataIndex: 'area',
        },
        {
          title: '国家',
          align: 'center',
          dataIndex: 'country',
        },
        {
          title: '城市',
          align: 'center',
          dataIndex: 'city',
        },
        {
          title: '名称',
          align: 'center',
          dataIndex: 'name',
        },
        // {
        //   title: '详细地址',
        //   align: 'center',
        //   dataIndex: 'address',
        // },
        {
          title: '类别',
          align: 'center',
          dataIndex: 'type_dictText',
        },
        {
          title: '等级',
          align: 'center',
          dataIndex: 'grade_dictText',
        },
        {
          title: '旋转角度',
          align: 'center',
          dataIndex: 'rotate',
        },
        {
          title: '经度',
          align: 'center',
          dataIndex: 'longitude',
        },
        {
          title: '纬度',
          align: 'center',
          dataIndex: 'latitude',
        },
        {
          title: '是否禁用',
          align: 'center',
          dataIndex: 'delFlag_dictText',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/infoshop.base/busInfoShopDataRecords/list',
        delete: '/infoshop.base/busInfoShopDataRecords/delete',
        deleteBatch: '/infoshop.base/busInfoShopDataRecords/deleteBatch',
        exportXlsUrl: '/infoshop.base/busInfoShopDataRecords/exportXls',
        importExcelUrl: 'infoshop.base/busInfoShopDataRecords/importExcel',
      },
      dictOptions: {},
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initDictConfig() {},
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
